import { render, staticRenderFns } from "./PostAdvisor.vue?vue&type=template&id=22b21af2&scoped=true&"
import script from "./PostAdvisor.vue?vue&type=script&lang=js&"
export * from "./PostAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./PostAdvisor.vue?vue&type=style&index=0&id=22b21af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b21af2",
  null
  
)

export default component.exports